const validateId = (id: string): boolean => {
  // source: https://www.cartaidentita.interno.gov.it/en/cie/cie-features/

  // ^[A-Z]{2}: Match exactly two uppercase letters at the start of the string.
  // \d{6}: Match exactly six digits.
  // OR
  // ^[A-Z]{2}: Match exactly two uppercase letters at the start of the string.
  // \d{5}: Match exactly five digits.
  // [A-Z]{2}: Match exactly two uppercase letters.
  const ID_REGEX = /^[A-Za-z]{2}(\d{5}[A-Za-z]{2}|\d{7})$/

  if (!id || id.length === 0) {
    return false
  }
  return ID_REGEX.test(id)
}

export default validateId
